<div class="page-content-container">
  <div class="dashboard-wrapper">
    <div class="dashboard-header">
      <div class="dashboard-title-block">
        <h2 class="dashboard-title">Producer Dashboard</h2>
        <p class="dashboard-subtitle">Manage your business operations and track performance</p>
      </div>
      <div class="header-actions">
        <a mat-stroked-button class="create-quote-btn" [href]="agentModeLink" target="_blank">
          <mat-icon>open_in_new</mat-icon>
          Create New Quote
        </a>
      </div>
    </div>

    <div class="tiles-grid">
      @for (tile of tiles; track tile.id) {
        <mat-card class="tile-card" (click)="navigate(tile.href)">
          <div class="tile-gradient"></div>
          <div class="tile-content">
            <div class="tile-top">
              <div class="tile-icon-wrap">
                <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
              </div>
              <mat-icon class="tile-arrow">chevron_right</mat-icon>
            </div>
            <h3 class="tile-title">{{ tile.title }}</h3>
            <p class="tile-description">{{ tile.description }}</p>
          </div>
        </mat-card>
      }
    </div>

    <div class="stats-grid">
      @for (stat of stats; track stat.label) {
        <mat-card class="stat-card">
          <div class="stat-value">{{ stat.value }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </mat-card>
      }
    </div>
  </div>
</div>
